import React from "react";
import { Table, Space } from "antd";

export default ({ cardList = [] }) => { 

    return (
        <Table
            size="small"
            columns={[
                {
                    title: "次卡名称",
                    dataIndex: "title",
                },
                {
                    title: "商品名称",
                    dataIndex: "title",
                    render: (text, record) => {
                        return record.good.title.substring(0, 10) + '...';
                    },
                },
                {
                    title: "操作",
                    render: (text, record) => { 
                        return <Space>
                            <a href={`/promotion/goods-card-template/create?cardTmpId=${record.cardTmpId}&action=edit`}>编辑</a>
                            {/* <a>删除</a> */}
                        </Space>
                    },
                },
            ]}

            dataSource={cardList}
        />
    );
};